import { Box, Button, MenuItem } from "@material-ui/core"
import { useEffect } from "react"
import type { ReactElement } from "react"
import { useForm } from "react-hook-form"

import { ChapterZone } from "../../../models"
import type { Licence, LinkChapter } from "../../../redux"
import { TextInputField } from "../../atoms"
import { FormValidationErrors, LicenceField } from "../../molecules"

import "./linkchapter-manager-form.styles.scss"
import { useTranslation } from "react-i18next"

export interface ILinkChapterManagerFormProps {
  chapter: LinkChapter
  licences: Licence[]
  saveChapter: (chapter: LinkChapter) => void
}

export function LinkChapterManagerForm(props: ILinkChapterManagerFormProps): ReactElement {
  const { chapter, licences, saveChapter } = props
  const {
    control,
    formState: { errors, submitCount },
    reset,
    handleSubmit
  } = useForm<LinkChapter>({
    defaultValues: chapter
  })

  const { t } = useTranslation("contentManager")
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    reset(chapter)
  }, [chapter])

  function onSubmit(data: LinkChapter): void {
    saveChapter(data)
  }

  return (
    <form className="link-chapter-manager-form" onSubmit={handleSubmit(onSubmit)}>
      <Box className="double-field">
        <TextInputField
          name="name"
          control={control}
          required={t("linkChapters.formFields.requiredChapterName")}
          label={t("linkChapters.formFields.linkChapterTitle")}
        />
        <LicenceField
          name="licenceIds"
          control={control}
          required={t("commonFormfields.requiredLicence")}
          label={t("commonFormfields.licences")}
          className="licence-field"
          licences={licences}
        />
      </Box>

      <Box className="double-field">
        <TextInputField
          name="order"
          control={control}
          required={t("commonFormfields.requiredOrderTableContents")}
          label={t("commonFormfields.orderTableContents")}
        />
        <TextInputField
          name="zone"
          control={control}
          required={t("linkChapters.formFields.requiredZone")}
          label={t("linkChapters.formFields.zonePage")}
          select
          defaultValue={ChapterZone.TOP}
        >
          <MenuItem value={ChapterZone.TOP}>{t("linkChapters.formFields.top")}</MenuItem>
          <MenuItem value={ChapterZone.BOTTOM}>{t("linkChapters.formFields.bottom")}</MenuItem>
        </TextInputField>
      </Box>

      <TextInputField
        name="thumbnailUrl"
        control={control}
        required={t("linkChapters.formFields.requiredThumbnail")}
        label={t("linkChapters.formFields.assetIdForThumbnail")}
      />
      <TextInputField
        name="url"
        control={control}
        required={t("linkChapters.formFields.requiredUrl")}
        label={t("linkChapters.formFields.urlDestinationChapter")}
      />

      <Button type="submit" variant="contained" color="primary">
        {t("save")}
      </Button>

      <FormValidationErrors errors={errors} submitCount={submitCount} />
    </form>
  )
}
